import '../index.css';
import React, { useState, useEffect } from 'react';
import HeaderAndFooter from './header-footer';
import GridBox from './GridBox';

function AppsPage() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 768);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    const menuStyles = {
        container: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            zIndex: 1000,
            backgroundColor: '#121212',
            padding: '10px 20px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
        },
        title: {
            color: '#ffffff',
            fontSize: '20px',
            fontWeight: '600',
            margin: 0,
        },
        hamburger: {
            cursor: 'pointer',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            gap: '6px',
        },
        hamburgerLine: {
            width: '25px',
            height: '2px',
            backgroundColor: '#ffffff',
            transition: 'all 0.3s ease',
        },
        menu: {
            position: 'fixed',
            top: '60px',
            left: 0,
            right: 0,
            backgroundColor: '#121212',
            padding: '20px',
            display: isMenuOpen ? 'flex' : 'none',
            flexDirection: 'column',
            gap: '15px',
            boxShadow: '0 4px 15px rgba(0,0,0,0.3)',
        },
        menuItem: {
            color: '#ffffff',
            textDecoration: 'none',
            padding: '10px',
            borderRadius: '5px',
            transition: 'all 0.3s ease',
            '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.1)',
            }
        }
    };

    const apps = [
        {
            name: "Card Pix",
            image: "/images/CardPixImage.png",
            description: "A multiplayer card game that turns your photos into playing cards. Compete, trade, and create unique decks.",
            terms: "Last Updated: Jan 16, 2024\n\nWelcome to Card Pix (\"Company,\" \"we,\" \"our,\" or \"us\"). These Terms of Service (\"Terms\") govern your use of our application and services (\"Services\"). By accessing or using our Services, you agree to comply with these Terms. If you do not agree, do not use our Services.\n\n1. User Responsibilities\nBy using our Services, you agree that you:\n• Are at least 18 years old or the legal age in your jurisdiction.\n• Own or have the necessary rights to any content you upload.\n• Will comply with all applicable laws and regulations.\n• Are responsible for all activity conducted through your account.\n\n2. Prohibited Content & Activities\nYou may not upload, post, or sell content that:\n• Infringes on copyrights, trademarks, or intellectual property rights of others.\n• Contains nudity, pornography, or sexually explicit material.\n• Depicts or promotes violence, hate speech, discrimination, or illegal activities.\n• Violates any local, state, national, or international laws.\n• Impersonates another person or entity.\n• Contains malicious software, viruses, or any content that disrupts our Services.\n\nIf you violate these rules, we may remove your content, suspend or terminate your account, and take legal action if necessary.\n\n3. Copyright & DMCA Compliance\nWe respect intellectual property rights and comply with the Digital Millennium Copyright Act (DMCA). If you believe your copyrighted work has been uploaded without permission, you may submit a DMCA Takedown Notice to us at philly.donnelly@gmail.com with the following:\n• Your contact information.\n• A description of the copyrighted work.\n• A link or identifier of the infringing content.\n• A statement that you believe the use is unauthorized.\n• A statement under penalty of perjury that your complaint is accurate.\n\nWe will act promptly to remove reported content and may suspend repeat infringers.\n\n4. Indemnification\nYou agree to indemnify, defend, and hold harmless Card Pix and its officers, employees, and affiliates from any claims, damages, liabilities, legal fees, or expenses arising from:\n• Your uploaded content, including copyright infringement and legal violations.\n• Your use of the Services.\n• Any breach of these Terms.\n\nWe reserve the right to assume exclusive defense in any matter subject to indemnification by you.\n\n5. Content Moderation & Removal\nWe may review and remove content that violates these Terms. We have the sole discretion to:\n• Remove or restrict access to content.\n• Suspend or terminate accounts that repeatedly violate our policies.\n• Report illegal content to authorities if necessary.\n\n6. Account Termination\nWe reserve the right to terminate or suspend your account if you violate these Terms. You may also terminate your account at any time.\n\n7. Limitation of Liability\nTo the fullest extent permitted by law, we are not liable for any damages, losses, or legal actions resulting from your use of the Services, including unauthorized uploads of copyrighted or illegal content.\n\n8. Changes to These Terms\nWe may update these Terms periodically. Continued use of our Services after changes constitutes acceptance of the updated Terms.\n\n9. Contact Information\nIf you have any questions about these Terms or need to file a DMCA complaint, contact us at philly.donnelly@gmail.com.\n\nBy using Card Pix, you acknowledge that you have read, understood, and agreed to these Terms of Service & Acceptable Use Policy.",
            privacy: "Last Updated: Jan 16, 2024\n\n1. Introduction\nWelcome to Card Pix. We are committed to respecting the privacy of all users. This Privacy Policy outlines our practices concerning the collection, use, and disclosure of your information when you use our app.\n\n2. Information We Collect\nGiven our commitment to your privacy, we do not collect any personal data from our users. Our app is designed to allow gameplay, image submission, and messaging without collecting data such as your name, address, email address, or phone number.\n\n3. How We Use Your Information\nSince we do not collect personal data, we do not use or share your information.\n\n4. Image Submission and AI Processing\nUsers can submit images from their camera roll to the app. These images are used solely for the purpose of gameplay and are not stored permanently on our servers. However, please note that:\n• Submitted images are processed by AI systems for image generation and categorization purposes\n• Images are only used during active gameplay sessions\n• Images are not stored permanently on our servers\n• You retain all rights to your uploaded images\n\n5. Game Center Integration\nOur app uses Apple's Game Center service for multiplayer functionality. This means:\n• Your Game Center account information is used to identify you in multiplayer games\n• Game Center handles all multiplayer matchmaking and player identification\n• We do not store or process your Game Center account information\n\n6. Messaging\nOur app allows users to message other players. Please note that we do not monitor or store these messages.\n\n7. Data Security and User-Submitted Content\nData Security: We take the security of our app seriously. However, as we do not collect personal data, there are no risks of such data being breached in terms of personal information.\nUser-Submitted Content: Our app allows users to submit images from their camera roll for use during gameplay. Please be aware that these images may be visible to other users during the course of a game. We urge you to exercise discretion and only upload images that you are comfortable having viewed by others in a public gameplay setting.\n\n8. Changes to Our Privacy Policy\nWe reserve the right to modify this privacy policy at any time. Changes and clarifications will take effect immediately upon their posting on the website.\n\n9. Contact Us\nIf you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us at philly.donnelly@gmail.com.",
            link: "https://apps.apple.com/us/app/card-pix/id6451060423"
        },
        {
            name: "Star Trailz",
            image: "/images/StarTrailzImage.png",
            description: "Embark on an epic space adventure in this single-player game. Navigate through challenging levels, collect characters, and explore the cosmos.",
            terms: "Last Updated: Jan 16, 2024\n\nWelcome to Star Trailz!\n\nThese terms and conditions outline the rules and regulations for the use of Star Trailz.\n\nBy accessing this app, we assume you accept these terms and conditions. Do not continue to use Star Trailz if you do not agree to take all of the terms and conditions stated on this page.\n\n1. Terms of App Use\nStar Trailz provides a single-player gaming experience that allows users to play through various levels and unlock content.\n\n2. User Responsibilities\nFair Play: Engage in fair play and respectful conduct during gameplay.\n\n3. Prohibited Uses\nIn addition to other prohibitions as set forth in the Terms and Conditions, you are prohibited from using the app or its content for any unlawful purpose, to solicit others to perform or participate in any unlawful acts, to violate any international or local regulations, laws, rules, etc.\n\n4. Termination\nWe may terminate or suspend access to our app immediately, without prior notice or liability, for any reason whatsoever, including, without limitation, if you breach the Terms and Conditions.\n\n5. Intellectual Property\nThe app and its original content, features, and functionality are and will remain the exclusive property of Phillip Donnelly.\n\n6. Limitation of Liability\nPhillip Donnelly will not be liable for any indirect, incidental, special, consequential or punitive damages resulting from your access to or use of, or inability to access or use, the app.\n\n7. Amendments to Terms and Conditions\nWe reserve the right to amend these Terms and Conditions at any time.\n\n8. Contact Information\nFor any questions about these Terms and Conditions, please contact us at philly.donnelly@gmail.com.",
            privacy: "Last Updated: Jan 16, 2024\n\nThe Star Trailz does not collect any personal information from any of your use of the Apps. If we have any of your personal information we will not willingly sell or give it to anyone, except if lawfully subpoenaed to produce it and then only after offering you a reasonable chance to challenge such subpoena if allowed by law.",
            link: "https://apps.apple.com/us/app/star-trailz/id6451060423"
        },
        {
            name: "Snube",
            image: "/images/SnubeImage.png",
            description: "A fast-paced arcade game where you control a cube through increasingly challenging obstacles. Perfect your timing and reflexes to achieve high scores.",
            terms: "Last Updated: Jan 16, 2024\n\nWelcome to Snube!\n\nThese terms and conditions outline the rules and regulations for the use of Snube.\n\nBy accessing this app, we assume you accept these terms and conditions. Do not continue to use Snube if you do not agree to take all of the terms and conditions stated on this page.\n\n1. Terms of App Use\nSnube provides a single-player gaming experience that allows users to play through various levels and achieve high scores.\n\n2. User Responsibilities\nFair Play: Engage in fair play and respectful conduct during gameplay.\n\n3. Prohibited Uses\nIn addition to other prohibitions as set forth in the Terms and Conditions, you are prohibited from using the app or its content for any unlawful purpose, to solicit others to perform or participate in any unlawful acts, to violate any international or local regulations, laws, rules, etc.\n\n4. Termination\nWe may terminate or suspend access to our app immediately, without prior notice or liability, for any reason whatsoever, including, without limitation, if you breach the Terms and Conditions.\n\n5. Intellectual Property\nThe app and its original content, features, and functionality are and will remain the exclusive property of Phillip Donnelly.\n\n6. Limitation of Liability\nPhillip Donnelly will not be liable for any indirect, incidental, special, consequential or punitive damages resulting from your access to or use of, or inability to access or use, the app.\n\n7. Amendments to Terms and Conditions\nWe reserve the right to amend these Terms and Conditions at any time.\n\n8. Contact Information\nFor any questions about these Terms and Conditions, please contact us at philly.donnelly@gmail.com.",
            privacy: "Last Updated: Jan 16, 2024\n\nThe Snube does not collect any personal information from any of your use of the Apps. If we have any of your personal information we will not willingly sell or give it to anyone, except if lawfully subpoenaed to produce it and then only after offering you a reasonable chance to challenge such subpoena if allowed by law.",
            link: "https://apps.apple.com/us/app/snube/id6451060423"
        }
    ];

    const styles = {
        container: {
            maxWidth: '1200px',
            margin: '0 auto',
            padding: '40px 20px',
            paddingTop: isMobile ? '80px' : '40px',
        },
        grid: {
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '40px',
            marginTop: '40px',
        },
        card: {
            backgroundColor: '#1a1a1a',
            borderRadius: '15px',
            overflow: 'hidden',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
            transition: 'transform 0.3s ease',
            border: '1px solid rgba(255, 255, 255, 0.1)',
        },
        imageContainer: {
            position: 'relative',
            width: '100%',
            paddingTop: '100%',
            overflow: 'hidden',
        },
        image: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            transition: 'transform 0.3s ease',
        },
        downloadButton: {
            display: 'block',
            width: '100%',
            padding: '15px',
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            color: '#fff',
            textDecoration: 'none',
            textAlign: 'center',
            transition: 'all 0.3s ease',
            borderTop: '1px solid rgba(255, 255, 255, 0.1)',
        },
        content: {
            padding: '20px',
        },
        title: {
            fontSize: '24px',
            fontWeight: '700',
            color: '#fff',
            marginBottom: '10px',
        },
        description: {
            fontSize: '16px',
            color: '#e0e0e0',
            lineHeight: '1.6',
            marginBottom: '20px',
        },
        terms: {
            fontSize: '14px',
            color: '#888',
            lineHeight: '1.6',
            marginTop: '20px',
            paddingTop: '20px',
            borderTop: '1px solid rgba(255, 255, 255, 0.1)',
            whiteSpace: 'pre-line',
        },
        privacy: {
            fontSize: '14px',
            color: '#888',
            lineHeight: '1.6',
            marginTop: '20px',
            paddingTop: '20px',
            borderTop: '1px solid rgba(255, 255, 255, 0.1)',
            whiteSpace: 'pre-line',
        }
    };

    return (
        <div>
            {isMobile ? (
                <div style={menuStyles.container}>
                    <h1 style={menuStyles.title}>Apps</h1>
                    <div 
                        style={menuStyles.hamburger}
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                    >
                        <div style={menuStyles.hamburgerLine}></div>
                        <div style={menuStyles.hamburgerLine}></div>
                        <div style={menuStyles.hamburgerLine}></div>
                    </div>
                    <div style={menuStyles.menu}>
                        <a href="/" style={menuStyles.menuItem}>HOME</a>
                        <a href="/apps" style={menuStyles.menuItem}>MY APPS</a>
                        <a href="https://onlinelibrary.wiley.com/doi/full/10.1002/admi.202101987" target="_blank" rel="noopener noreferrer" style={menuStyles.menuItem}>RESEARCH</a>
                        <a href="https://www.amazon.com/Fairy-Tales-Shadows-Fantasy-Stories-ebook/dp/B0BV81XBQZ" target="_blank" rel="noopener noreferrer" style={menuStyles.menuItem}>MY BOOK</a>
                    </div>
                </div>
            ) : (
                <HeaderAndFooter.Header classNames="w3-button w3-black w3-hover-purple nav-button" />
            )}
            
            <div style={styles.container}>
                <div style={styles.grid}>
                    {apps.map((app, index) => (
                        <div key={index} style={styles.card}>
                            <a href={app.link} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                                <div style={styles.imageContainer}>
                                    <img 
                                        src={app.image} 
                                        alt={app.name}
                                        style={styles.image}
                                        onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                        onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                    />
                                </div>
                            </a>
                            <a 
                                href={app.link} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                style={styles.downloadButton}
                                onMouseOver={(e) => e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.2)'}
                                onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)'}
                            >
                                Download on App Store
                            </a>
                            <div style={styles.content}>
                                <h2 style={styles.title}>{app.name}</h2>
                                <p style={styles.description}>{app.description}</p>
                                <p style={styles.terms}>{app.terms}</p>
                                <p style={styles.privacy}>{app.privacy}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <HeaderAndFooter.Footer />
        </div>
    );
}

export default AppsPage;

